import axios from 'axios'

export default {
  fetchForms: () => axios.get('/forms'),

  fetchConsents: () => axios.get('/consents'),

  fetchConsent:(id) => axios.get('/consents/' + id),

  createConsents: (data) => axios.post('/consents/createMany', data),

  createConsent: data => axios.post('/consents/create', data),

  isInForm: (mode) => axios.get('/consents/isInForm/' + mode.mode),

  filterConsents: (filters) => axios.post('consents/filter', filters),

  updateConsent:(editConsentDTO) => axios.put('consents/edit', editConsentDTO)

  // isInForm:(mode) => axios.post('/consents/isInForm', mode.mode)

}
